import {createFeatureSelector, createSelector} from '@ngrx/store';
import {
  DelegoPaymentState,
  PAYMENT_AUTHORIZATION_FEATURE,
  stripeInitialState,
  StripePaymentState
} from '../payment-state';
import {StripeActions, StripeActionTypes} from '../actions/stripe.action';

const getStripeFeatureState = createFeatureSelector<{
  delego: DelegoPaymentState;
  stripe: StripePaymentState;
}>(PAYMENT_AUTHORIZATION_FEATURE);

export const getState = createSelector(getStripeFeatureState, (state) => state.stripe);

export const stripeReducer = (state = stripeInitialState, action: StripeActions): StripePaymentState => {
  switch (action.type) {
    case StripeActionTypes.StartStripePaymentFlow:
      return {
        ...state,
        loading: true,
        isPaymentIntentRequired: false,
        data: undefined,
        error: false,
      };
    case StripeActionTypes.CreatePaymentIntentSuccess:
      return {
        ...state,
        isPaymentIntentRequired: true,
        data: action.payload,
        loading: false
      };
    case StripeActionTypes.Invoke3dsFailure:
    case StripeActionTypes.CreatePaymentIntentFailure:
      return {
        ...state,
        isPaymentIntentRequired: true,
        error: action.payload,
        loading: false,
      };
    case StripeActionTypes.PaymentIntentNotRequired:
      return {
        ...state,
        isPaymentIntentRequired: false,
        loading: false,
      };
    default:
      return state;
  }
};
